module.exports = __webpack_public_path__ + "img/DNARepair-CRC_GSE206552.5486a8a1.png";